import "easy-autocomplete";

function encodeHTML(str) {
    const div = document.createElement('div');
    div.textContent = str;
    return div.innerHTML;
}

export default function () {
    const elements = document.querySelectorAll('[data-autocomplete-method]');

    elements.forEach(element => {
        const options = {
            url: function (phrase) {
                return `${$("body").data("approot")}/panel/methods/autocomplete?method=${element.getAttribute("data-autocomplete-method")}&phrase=${phrase}`;
            },
            requestDelay: 500,
            getValue: "entered",
            list: {
                onChooseEvent: function () {
                    const item = $(element).getSelectedItemData();
                    if (item && item.id) {
                        $("#SelectedProductId").val(item.id).trigger("change");
                        __doPostBack();
                    }
                },
                maxNumberOfElements: 20,
            },
            template: {
                type: "custom",
                method: function (value, item) {
                    item.text = encodeHTML(item.text);
                    item.additional = encodeHTML(item.additional);

                    if (item.link) {
                        return `<img src="${item.icon}" /> <a href="${item.link}">${item.text}</a><small>${item.additional}</small>`;
                    } else {
                        return `<div><img src="${item.icon}" /> ${item.text}<small>${item.additional}</small></div>`;
                    }
                }
            }
        };

        $(element).easyAutocomplete(options);
    });
}
